// Personalized Homepage Template
export default {
  templateName: 'Personalized Homepage',
  metaData: {
    Route: {
      RouteMapping: [
        {
          RouteURL: '/c/mcp-test-2',
          IsEnabled: 'Yes'
        },
        {
          RouteURL: '/c/personalized-homepage',
          IsEnabled: 'Yes'
        }
      ]
    },
    CategoryId: '60198658',
    SeoSettings: {
      PageTitle: 'Nordstrom Online & In Store: Shoes, Jewelry, Clothing, Makeup, Dresses',
      PageDescription:
        'Free shipping. Free returns. All the time. Shop online for shoes, clothing, jewelry, dresses, makeup and more from top brands. Make returns in store or by mail.',
      CanonicalUrl: 'https://shop.nordstrom.com/'
    }
  },
  newComponents: [
    {
      componentVariation: 'Tile',
      name: 'Personalized HP Tile',
      templateName: 'Personalized HP Tile'
    }
  ],
  existingComponents: [
    // 03.16_SBCDesigner_PHPTile
    '97479454-f064-409d-a028-18df635b122c',

    // 03.16_SBCMen_PHPTile
    'a7204fc4-4f75-474c-9b60-ac2ec8f148ee',

    // 03.16_SBCWomens_PHPTile
    'fed93f42-79b1-4525-b1c2-fbd97a8100ef',

    // 03.16_SBCKids_PHPTile
    '70c14a43-9a00-4572-9ce9-3a26d884b303',

    // 03.16_SBCHome_PHPTile
    'b0cb5433-4f18-412e-bf0d-a2fb40dd6572',

    // 04.20_SBCBeauty_PHPTile
    '10294cc9-c3f9-49f6-b482-e748446baa92',

    // HP1-1_MOW_Rec3.0
    '5ee274a7-448e-4e37-84f4-41066f02dd4a',

    // HP1-2_MOW_Rec3.0
    'dc07f637-6785-4416-9766-2c5274d9f74a',

    // HP1-3_MOW_Rec3.0
    'ef883d7d-9300-4045-8d61-8957518e9dc3',

    // HP1-4_MOW_Rec3.0
    '6d45e9de-2d59-4f98-8cec-af4d7a96c5b4',

    // HP1-5_MOW_Rec3.0
    '5110838f-c64a-4342-8e8c-84022f75e129'
  ],
  requiredComponents: [
    {
      componentVariation: 'Recommendations 3.0',
      minRequired: 4
    },
    {
      componentVariation: 'Ranked Results',
      minRequired: 2
    },
    {
      componentVariation: 'Tile',
      templateName: 'HP - Services',
      minRequired: 3
    }
  ]
};
